// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-15T00:30:37.165Z
// Property: Ashbrook Run Apartments (ID: 6767906449167346)
// Collections: 12 amenities, 3 floorplans (live), 6 photos, 36 POIs, 2 reviews, 6 virtual tours, 5 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167346",
  "property_external_id": "4059828",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/ashbrook-run-apartments-canal-winchester-oh/jkjy9e4/",
  "property_google_business_url": "https://www.google.com/maps/place/Ashbrook+Run+Apartments/data=!4m2!3m1!1s0x0:0x69b3ec48712b703c?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "4059828",
  "property_status": null,
  "property_slug": "ashbrook-run-apartments",
  "property_name": "Ashbrook Run Apartments",
  "property_website_url": "https://www.ashbrookrun.com/",
  "property_domain": "https://www.ashbrookrun.com/",
  "property_address": "5222 Flower Valley Dr",
  "property_full_address": "5222 Flower Valley Dr, Canal Winchester, OH 43110",
  "property_address_1": "5222 Flower Valley Dr",
  "property_address_2": null,
  "property_address_city": "Canal Winchester",
  "property_address_state": "OH",
  "property_address_zip_full": "43110-8520",
  "property_address_zip": "43110",
  "property_address_country": "US",
  "property_address_county": "Franklin County",
  "property_neighborhood_address": "Schirm Farm",
  "property_address_latitude": "39.8718357",
  "property_address_longitude": "-82.8347998",
  "property_email": "ara@dietzpropertygroup.com",
  "property_phone": "(614) 834-9571",
  "property_call_tracking_phone": "614-412-3807",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Ashbrook Run Apartments in Canal Winchester, OH, where spacious floor plans meet modern comforts. Our pet-friendly community features upgraded townhouses, keyless entry, and on-site maintenance. Enjoy 24-hour emergency services, stylish patios, and convenient washer/dryer options. Your ideal new home awaits—explore our availability or schedule a tour today!",
  "property_long_description": "### Welcome to Ashbrook Run Apartments in Canal Winchester, OH!\n\nExperience the perfect blend of comfort and convenience at Ashbrook Run Apartments, where your ideal living space awaits! Our community features thoughtfully designed floor plans, including one-bedroom and spacious two-bedroom options, tailored to fit your lifestyle. Each apartment boasts modern amenities and flexible living solutions, ensuring you feel right at home from day one.\n\nNestled in a prime location, Ashbrook Run offers easy access to shopping, dining, and entertainment, making it the perfect combination of tranquility and accessibility. Our townhouse-style property is pet-friendly, allowing you to share your new home with your furry companions. Enjoy the luxury of on-site maintenance and 24-hour emergency services, ensuring your comfort and peace of mind at all times.\n\nTake advantage of our wide array of amenities, including keyless entry with a keypad system, smart card capabilities, and remote-controlled features for added convenience. Our upgraded tier options provide even more choices to customize your living experience, while spacious closets and patios create a perfect space for relaxation. Whether you prefer a first or second-floor apartment, each unit is equipped with central heat and air conditioning, making your home cozy year-round.\n\nDon’t miss out on our attractive flexible rent payment options, designed to suit your financial needs. With our professional management team dedicated to fostering a welcoming community, you’ll find everything you need at Ashbrook Run Apartments.\n\nReady to make the move? Find your new home today—browse our availability or schedule a tour to explore our community! Your future starts here at Ashbrook Run!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
    "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
    "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
    "width": 1284,
    "height": 996
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "292",
  "property_year_built": "2009",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.2054794520548",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Pets allowed: cats and small dogs only. Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Pets allowed: cats and small dogs only. Maximum of 2 pets per unit. One-time non-refundable pet fee: $200 per pet. Monthly pet rent: $35 per pet.",
  "property_petpolicy_info": "Pet & Parking Policy   \n\nPet Policy Type: Cat, Dogs   \n\nMax Number of Pets: 2   \n\nOne-time pet fee: $200   \n\nPet policy: Pet friendly community. Cats and small dogs allowed. $200 one-time pet fee (non-refundable), plus $35 pet rent (per month/per pet).",
  "property_online_leasing_url": "https://oll-leasing.loftliving.com/oll/?siteId=4059828",
  "property_resident_portal_url": "https://ashbrookrun.loftliving.com/login",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-726f-72be-9b1a-72411cb97308.webp",
  "property_primary_logo_media": {
    "alt_text": "Ashbrook Run Apartments logo",
    "public_id": "019d63ad-726f-72be-9b1a-72411cb97308",
    "storage_key": "property/6767906449167346/019d63ad-726f-72be-9b1a-72411cb97308.webp",
    "width": 700,
    "height": 127
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-cc97-77f4-a301-0e22faeedbe2.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d63ad-cc97-77f4-a301-0e22faeedbe2",
    "storage_key": "property/6767906449167346/019d63ad-cc97-77f4-a301-0e22faeedbe2.webp",
    "width": 700,
    "height": 127
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-b26a-7234-aa2b-163d2788aa44.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d63ad-b26a-7234-aa2b-163d2788aa44",
    "storage_key": "property/6767906449167346/019d63ad-b26a-7234-aa2b-163d2788aa44.webp",
    "width": 700,
    "height": 127
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": "#7398a0",
  "property_color_3": "#4a759f",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "816 - 1348",
  "property_sqft_min": "816",
  "property_sqft_max": "1348",
  "property_price_range": "200 - 1490",
  "property_price_min": "200",
  "property_price_max": "1490",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/people/Ashbrook-Run-Apartments/100077695201896/#",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJXUiPcm98OIgRPHArcUjss2k",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/ashbrook-run-apartments-by-champion-property-management-canal-winchester",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Ashbrook Run Apartments",
  "property_home_romance_title": "Embrace the Joy of Living at Your Dream Apartment Home",
  "property_home_amenities_blurb": "Welcome to Ashbrook Run Apartments in Canal Winchester, OH, where comfort meets convenience. Choose from spacious one and two-bedroom layouts, featuring model homes and pet-friendly options. Enjoy modern amenities like central air, private patios, and responsive on-site maintenance, all in a vibrant community designed for your lifestyle. ",
  "property_home_floorplans_blurb": "Welcome to Ashbrook Run Apartments in Canal Winchester, OH, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom floor plans, each tailored to suit your lifestyle. Ready to elevate your living experience? Browse our available apartment homes today and uncover your ideal sanctuary.",
  "property_home_gallery_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, choose from spacious one and two-bedroom layouts complete with modern amenities. Enjoy the convenience of a keypad entry, on-site maintenance, and pet-friendly policies. Relax on your private balcony or patio and experience flexible rent options tailored to your lifestyle. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Ashbrook Run Apartments in Canal Winchester, enjoy spacious one and two-bedroom floor plans surrounded by vibrant local attractions. Dive into adventure at Magic Mountain Fun Center, or explore serene trails at Blacklick Woods Metro Park. Your ideal home is just minutes away from enriching experiences and community amenities!",
  "property_home_reviews_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, our residents rave about their experiences. With a perfect 5.0 rating, Aisha’s nurturing support makes every tenant feel at home, while our dedicated maintenance team, led by Steven, ensures everything runs smoothly. Join a community where care and attention shine! See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in Canal Winchester, Ashbrook Run Apartments offers more than just stylish one and two-bedroom homes; it’s a gateway to adventure. Enjoy nearby parks, top-notch fitness centers like Crunch Fitness and Life Time, and cultural sites such as the AMA Motorcycle Hall of Fame. Embrace the vibrant community around you!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, comfort meets modern living. Choose from spacious one and two-bedroom floor plans, featuring inviting patios, smart home technology, and pet-friendly policies. With 24-hour emergency maintenance and professional management, your ideal home awaits. Experience the convenience of flexible rent payments and upgraded amenities today!",
  "property_applynow_blurb": "Welcome to Ashbrook Run Apartments in Canal Winchester, OH, where spacious two-bedroom and one-bedroom layouts meet modern living. Enjoy pet-friendly amenities, dazzling patios, smart technology, and 24-hour maintenance in a serene neighborhood. Transform your lifestyle today—secure your ideal home and lease online with ease!",
  "property_contactus_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, our thoughtfully designed one- and two-bedroom floor plans cater to your lifestyle needs. Embrace comfort and convenience in a welcoming community where every detail is crafted for you. Have questions? Contact our leasing team today and start your journey home!",
  "property_faqs_blurb": "Nestled in the heart of Canal Winchester, OH, Ashbrook Run Apartments offers thoughtfully designed one and two-bedroom floor plans tailored for your comfort. Curious about our community? Visit our FAQs page for insights on amenities, living, and more to help you make the best choice for your next home!",
  "property_floorplans_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, enjoy spacious living with thoughtfully designed floor plans. Choose from our inviting one-bedroom and two-bedroom layouts, perfect for any lifestyle. With various options to suit your needs, browse our available apartment homes to find the ideal space that feels like home.",
  "property_gallery_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, your dream home awaits. Choose from spacious one and two-bedroom floor plans featuring modern amenities like smart card access and 24-hour maintenance. Enjoy pet-friendly living with private balconies and upgraded features. Picture yourself thriving in this vibrant community!",
  "property_interactivemap_blurb": "Welcome to Ashbrook Run Apartments in Canal Winchester, OH—where spacious two and one-bedroom floor plans meet modern convenience. Enjoy pet-friendly living with 24-hour emergency maintenance, upgraded amenities, and an ideal location. Use our interactive community map to find your new home and experience unmatched comfort today!",
  "property_pets_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, your furry companions are cherished! With ample space for your cats and small dogs, our pet-friendly community ensures they’ll feel right at home. Enjoy life together with beautiful surroundings and thoughtful amenities designed for both you and your pets.",
  "property_referafriend_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, choosing your perfect home is easy with our spacious one and two-bedroom floor plans. Elevate your living experience and foster wonderful friendships in a vibrant community. Great friends make great neighbors—refer a friend to join our welcoming atmosphere today!",
  "property_residentaccess_blurb": "Welcome to Ashbrook Run Apartments in scenic Canal Winchester, OH, where comfort meets convenience. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Need a quick tune-up? Access your resident portal to effortlessly pay rent, schedule maintenance, and stay connected with your community.",
  "property_reviews_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, our residents rave about their experience! One resident shares, “Aisha is like a sister to me,” highlighting the caring and attentive management that sets us apart. See what our residents have to say about living in our welcoming community!",
  "property_created_at": "1775493760416",
  "property_scheduletour_blurb": "At Ashbrook Run Apartments in Canal Winchester, OH, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Experience vibrant community living and see what our residents love about their homes. Schedule a tour today to envision your new lifestyle!",
  "property_thankyou_blurb": "Thank you for reaching out to Ashbrook Run Apartments in Canal Winchester, OH! We're excited to showcase our beautifully designed one and two-bedroom floor plans. Stay tuned for a personalized response from our team, ready to help you find your perfect home in our vibrant community.",
  "property_virtualtours_blurb": "Step into the inviting charm of Ashbrook Run Apartments in Canal Winchester, OH. With spacious one and two-bedroom floor plans designed for comfort, every corner feels like home. Dive into our virtual tour and experience the vibrant community and stylish living spaces waiting for you! ",
  "property_copyright": "2026 All Rights Reserved. Ashbrook Run Apartments",
  "property_seo_title_home": "Ashbrook Run Apartments |  Apartments in Canal Winchester, OH",
  "property_seo_description_home": "Discover Ashbrook Run Apartments in Canal Winchester! Enjoy spacious layouts, pet-friendly perks, and outstanding management. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Canal Winchester, OH Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Ashbrook Run Apartments in Canal Winchester, OH! Choose from stylish one- and two-bedroom floor plans designed for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Canal Winchester, OH Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Ashbrook Run Apartments in Canal Winchester! Enjoy spacious layouts, pet-friendly policies, and modern amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in Canal Winchester, OH",
  "property_seo_description_gallery": "Discover Ashbrook Run Apartments in Canal Winchester, OH—spacious floor plans, modern amenities, pet-friendly living, and a vibrant community await!",
  "property_seo_title_virtualtours": "Virtual Tours | Ashbrook Run Apartments Apartments",
  "property_seo_description_virtualtours": "Step into Ashbrook Run Apartments in Canal Winchester, OH! Take a virtual tour of our stylish one and two-bedroom homes. Your new adventure awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Ashbrook Run Apartments Apartments",
  "property_seo_description_interactivemap": "Discover Ashbrook Run Apartments in Canal Winchester, OH—spacious, pet-friendly homes in a prime location. Let’s map your future!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Canal Winchester, OH",
  "property_seo_description_neighborhood": "Discover Ashbrook Run Apartments in Canal Winchester! Enjoy local favorites and explore the vibrant neighborhood culture around your new home.",
  "property_seo_title_contact": "Contact Us | Ashbrook Run Apartments",
  "property_seo_description_contact": "Connect with Ashbrook Run Apartments in Canal Winchester, OH! Whether you're eyeing our one or two-bedroom floor plans, our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Canal Winchester, OH",
  "property_seo_description_faqs": "Get answers to your questions about Ashbrook Run Apartments in Canal Winchester, OH. Learn about amenities, floor plans, and more to find your ideal home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Canal Winchester, OH",
  "property_seo_description_reviews": "Discover Ashbrook Run Apartments in Canal Winchester, OH. Enjoy spacious, pet-friendly homes and premium amenities—see resident reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Canal Winchester, OH",
  "property_seo_description_applynow": "Discover your ideal home at Ashbrook Run Apartments in Canal Winchester! Enjoy spacious layouts, pet-friendly options, and great amenities. Lease online!",
  "property_seo_title_residentaccess": "Resident Access | Ashbrook Run Apartments",
  "property_seo_description_residentaccess": "Access your Ashbrook Run Apartments resident portal in Canal Winchester, OH! Pay rent, schedule maintenance, and manage your living experience seamlessly.",
  "property_seo_title_referafriend": "Refer A Friend | Ashbrook Run Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Ashbrook Run Apartments in Canal Winchester, OH, and enjoy the perks of living in a thriving community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Ashbrook Run Apartments",
  "property_seo_description_scheduletour": "Experience comfort and style at Ashbrook Run Apartments in Canal Winchester, OH. Schedule your tour today and find your perfect home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Ashbrook Run Apartments",
  "property_seo_description_privacy": "Your privacy matters at Ashbrook Run Apartments. Learn how we protect your data while you enjoy life in Canal Winchester. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Ashbrook Run Apartments",
  "property_seo_description_accessibility": "Join us at Ashbrook Run Apartments in Canal Winchester, OH, where accessibility meets comfort. Your experience matters—let us enhance your digital journey!",
  "property_seo_title_sitemap": "Sitemap | Ashbrook Run Apartments",
  "property_seo_description_sitemap": "Uncover every corner of Ashbrook Run Apartments in Canal Winchester, OH. Navigate our sitemap for a seamless journey through your future home.",
  "property_seo_title_thankyou": "Thank You | Ashbrook Run Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! We're excited to connect and help you discover your future home at Ashbrook Run Apartments in Canal Winchester, OH. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Canal Winchester, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1782412626160",
  "amenities": [
    {
      "id": "ec_03a870124b7bc3a07b020d35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000338",
      "title": "Pet Friendly",
      "amount": "0.0000",
      "description": "Pet Friendly",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e30bde98b7f7ada15e696e0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000617",
      "title": "Professional Management",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de0dc75e39f17e99436279a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000619",
      "title": "Ideal Location",
      "amount": "0.0000",
      "description": "Nearby Shopping and Entertainment",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44997b208d43a97eb2ba963e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000698",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Large fitness center (750 sq. ft. + with at   least 10 machines) ",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9dc134204e1919ff72f1c6b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000701",
      "title": "24 Hour Emergency Maintenance",
      "amount": "0.0000",
      "description": "24 Hour Emergency Maintenance",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1a91beabd4fe4ab9fdfbdbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000702",
      "title": "Flexible Rent Payments",
      "amount": "0.0000",
      "description": "Flexible Rent Payments",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18299ca899f58e875d8ecaa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000663",
      "title": "Patio / Balcony",
      "amount": "25.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cee02d85ffa4bb5779d17afb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000665",
      "title": "Washer/Dryer Hookup",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_121beb0ea43526f7944ad9ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000683",
      "title": "Kitchen Disposal",
      "amount": "0.0000",
      "description": "Garbage disposal",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a5a6ef49b54ed8cf7af4cc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000684",
      "title": "Walk-in Closets",
      "amount": "0.0000",
      "description": "Walk-in Closets",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee315ec3ef274ab4a448ec7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000685",
      "title": "Microwave",
      "amount": "15.0000",
      "description": "Under cabinet",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df5e6adbbb8774eeabc3ff24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "realpage",
      "external_id": "P000000693",
      "title": "Central Heat & Air",
      "amount": "0.0000",
      "description": "Central Heat & Air Conditionin",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_65a7a217-b5ac-439a-bf1e-21db5c5768c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-1fff-711a-ae1a-d2a80d500670.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping at Ashbrook Run Apartments.",
        "public_id": "019d63af-1fff-711a-ae1a-d2a80d500670",
        "storage_key": "property/6767906449167346/019d63af-1fff-711a-ae1a-d2a80d500670.webp",
        "width": 1210,
        "height": 806
      },
      "title": "Community",
      "description": "Charming apartment exteriors featuring private balconies and well-maintained grounds, offering a comfortable living experience.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping at Ashbrook Run Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bef1ee2d-721c-4561-85b1-99c992b8a150",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-20cc-7177-b471-ef8472e3e6d2.webp",
      "image_media": {
        "alt_text": "Apartment buildings with balconies and green spaces at Ashbrook Run Apartments.",
        "public_id": "019d63af-20cc-7177-b471-ef8472e3e6d2",
        "storage_key": "property/6767906449167346/019d63af-20cc-7177-b471-ef8472e3e6d2.webp",
        "width": 1210,
        "height": 806
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings with balconies and lush green lawns, creating a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Apartment buildings with balconies and green spaces at Ashbrook Run Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6840c8b-36af-48f7-8775-0fc4840e658e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-0e0a-7023-a890-0bcafeb274ff.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and a decorative rug at Ashbrook Run Apartments.",
        "public_id": "019d63af-0e0a-7023-a890-0bcafeb274ff",
        "storage_key": "property/6767906449167346/019d63af-0e0a-7023-a890-0bcafeb274ff.webp",
        "width": 1518,
        "height": 1012
      },
      "title": "Apartment",
      "description": "A compact kitchen featuring light wood cabinetry, a white stove and refrigerator, and a decorative floral rug on the floor. The space includes a sink and a countertop with a potted plant.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, white appliances, and a decorative rug at Ashbrook Run Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_00b2463c-1131-41cf-aaf2-b940b59d58c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-131f-7119-817d-cfa2220da1dc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background at Ashbrook Run Apartments.",
        "public_id": "019d63af-131f-7119-817d-cfa2220da1dc",
        "storage_key": "property/6767906449167346/019d63af-131f-7119-817d-cfa2220da1dc.webp",
        "width": 1210,
        "height": 806
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background at Ashbrook Run Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_819efd65-ca50-4064-996d-a0a29809055d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-037f-7799-b22f-98e75bdbe7e3.webp",
      "image_media": {
        "alt_text": "Brick building with American flag and landscaping, adjacent to a fenced pool area at Ashbrook Run Apartments.",
        "public_id": "019d63af-037f-7799-b22f-98e75bdbe7e3",
        "storage_key": "property/6767906449167346/019d63af-037f-7799-b22f-98e75bdbe7e3.webp",
        "width": 1210,
        "height": 806
      },
      "title": "Community",
      "description": "Enjoy our beautiful community amenities, including this sparkling outdoor pool and well-maintained grounds.",
      "link": "",
      "alt_text": "Brick building with American flag and landscaping, adjacent to a fenced pool area at Ashbrook Run Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3c0d337-d3db-4e11-b26d-46dc20971f46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-f9b8-7646-b61d-52f74f688a13.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and curtains  at Ashbrook Run Apartments.",
        "public_id": "019d63ae-f9b8-7646-b61d-52f74f688a13",
        "storage_key": "property/6767906449167346/019d63ae-f9b8-7646-b61d-52f74f688a13.webp",
        "width": 1210,
        "height": 805
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant nightstands, and tasteful decor, creating a cozy and inviting atmosphere.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and curtains  at Ashbrook Run Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_53b26c40-ab8e-470b-9d3b-0f5d638ec1ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2364 Taylor Park Dr, Reynoldsburg, OH 43068, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves amazing sandwiches, salads, and milkshakes. They highlight the generous portions, fresh ingredients, and delicious avocado dressing. They also like the fast and friendly service, and the efficient drive-thru setup.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-8463-727f-b332-19eb5858a29c.webp",
      "poi_featured_image_media": {
        "alt_text": "Chick-fil-A restaurant exterior with American flag waving.",
        "public_id": "019d63ad-8463-727f-b332-19eb5858a29c",
        "storage_key": "property/6767906449167346/019d63ad-8463-727f-b332-19eb5858a29c.webp",
        "width": 1122,
        "height": 703
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/oh/reynoldsburg-oh?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8356650332493229614&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "39.9360863",
      "poi_longitude": "-82.790735",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-501-1719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing dining or a restaurant",
        "public_id": "019d63b0-103f-743d-8f6a-c64d11b5cf10",
        "storage_key": "property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQey5jNlOIgRLq5otDPJ-HM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_ac3bd4b4-cf6d-43a2-a7a0-812140fcd954",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Roosters",
      "poi_type": "Restaurants",
      "poi_address": "1500 Stonecreek Dr, Pickerington, OH 43147, USA",
      "poi_short_description": "Outpost of a casual chain serving American comfort food & specializing in chicken wings.",
      "poi_long_description": "People say this chicken wings restaurant serves delicious food. They highlight the great prices and the homey vibe. They also like the friendly staff and great service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d7918-86ab-77fa-a3cf-26313a78b9ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-86ab-77fa-a3cf-26313a78b9ad",
        "storage_key": "property/6767906449167346/019d7918-86ab-77fa-a3cf-26313a78b9ad.webp",
        "width": 1280,
        "height": 1062
      },
      "poi_business_url": "http://www.roosterswings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2042404700479525044&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roosters",
      "poi_latitude": "39.915093",
      "poi_longitude": "-82.7832013",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 614-577-9601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing dining or a restaurant",
        "public_id": "019d63b0-103f-743d-8f6a-c64d11b5cf10",
        "storage_key": "property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSmZVyl7OIgRtJCrA0EUWBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_78ac4d1c-884b-493c-9ee2-abac67e41123",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "1912 OH-256, Reynoldsburg, OH 43068, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "People say this American restaurant serves delicious burgers, fish sandwiches, and frozen custard. They also highlight the friendly service and outstanding atmosphere.\n\nSome reviews mention that orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-bc62-7596-ab12-2ef631b8f5ae.webp",
      "poi_featured_image_media": {
        "alt_text": "Culver's restaurant exterior with picnic tables outside",
        "public_id": "019d63ae-bc62-7596-ab12-2ef631b8f5ae",
        "storage_key": "property/6767906449167346/019d63ae-bc62-7596-ab12-2ef631b8f5ae.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.culvers.com/restaurants/reynoldsburg/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=4510283300028236272&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "39.9448691",
      "poi_longitude": "-82.7947518",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-604-7759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing dining or a restaurant",
        "public_id": "019d63b0-103f-743d-8f6a-c64d11b5cf10",
        "storage_key": "property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq1rmzOtkOIgR8EGPzsO-lz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9a09f8f0-78ab-4477-87da-b6e758c5998c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5940 E Main St, Columbus, OH 43213, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and margaritas. They also highlight the good value, fun atmosphere, and attentive service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-8c79-704f-8484-d3fa686d50b1.webp",
      "poi_featured_image_media": {
        "alt_text": "Texas Roadhouse restaurant exterior with prominent signage.",
        "public_id": "019d63ad-8c79-704f-8484-d3fa686d50b1",
        "storage_key": "property/6767906449167346/019d63ad-8c79-704f-8484-d3fa686d50b1.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/ohio/columbus-reynoldsburg?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=16650583739072273694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "39.9558024",
      "poi_longitude": "-82.8407763",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-322-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing dining or a restaurant",
        "public_id": "019d63b0-103f-743d-8f6a-c64d11b5cf10",
        "storage_key": "property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkXsVgW1jOIgRHl1MLrHBEuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4b8456ff-2ee3-4974-b4cc-1a385ad0b182",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "1860 Winderly Ln, Pickerington, OH 43147, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-8890-7498-a412-b47740d0a2b2.webp",
      "poi_featured_image_media": {
        "alt_text": "Cracker Barrel restaurant exterior with rocking chairs on the porch and blooming trees.",
        "public_id": "019d63ad-8890-7498-a412-b47740d0a2b2",
        "storage_key": "property/6767906449167346/019d63ad-8890-7498-a412-b47740d0a2b2.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/oh/pickerington/121/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=13106836088295861674&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "39.9320664",
      "poi_longitude": "-82.79030809999999",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 614-759-7799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing dining or a restaurant",
        "public_id": "019d63b0-103f-743d-8f6a-c64d11b5cf10",
        "storage_key": "property/6767906449167346/019d63b0-103f-743d-8f6a-c64d11b5cf10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWbdfcVkOIgRqi0ltPrV5LU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_92eb4326-55b8-4a6d-9e26-99b060f2aecd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Saraga International Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "2750 S Hamilton Rd, Columbus, OH 43232, USA",
      "poi_short_description": "Grocery with a broad selection of produce, including live fish, and a variety of prepared foods and restaurants.",
      "poi_long_description": "People say this grocery store offers a large selection and variety of international foods, fresh produce, and fresh meats and seafood. They also highlight the unique and diverse selection of foods from different cultures, and the availability of hard-to-find ingredients.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-8453-7159-8352-b2e48b62ba9f.webp",
      "poi_featured_image_media": {
        "alt_text": "Saraga International Grocery store building entrance with a parking lot in front.",
        "public_id": "019d63ad-8453-7159-8352-b2e48b62ba9f",
        "storage_key": "property/6767906449167346/019d63ad-8453-7159-8352-b2e48b62ba9f.webp",
        "width": 1436,
        "height": 833
      },
      "poi_business_url": "http://saragaohio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2835537481090059819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saraga-international-grocery",
      "poi_latitude": "39.92226489999999",
      "poi_longitude": "-82.8779441",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 614-604-7653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0ff0-741c-a1c8-e4b66e5981b1.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63b0-0ff0-741c-a1c8-e4b66e5981b1",
        "storage_key": "property/6767906449167346/019d63b0-0ff0-741c-a1c8-e4b66e5981b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFc8NUCR9OIgRK86t01DaWSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b78877d6-319e-408e-a86a-1e809e0a941c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2480 Brice Rd, Reynoldsburg, OH 43068, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of tools, paints, cleaning supplies, plants, and flowers. They also highlight the helpful staff, good prices, and clean, well-organized store.\n\nOther reviews mention the return policy can be unclear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-7c17-72f9-a751-413d6498806a.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot store exterior with entrance and merchandise displayed outside.",
        "public_id": "019d63ad-7c17-72f9-a751-413d6498806a",
        "storage_key": "property/6767906449167346/019d63ad-7c17-72f9-a751-413d6498806a.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Brice-Road/OH/Reynoldsburg/43068/3816?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7917839494225467413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.9346198",
      "poi_longitude": "-82.82894170000002",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 614-577-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0f91-76bf-96c8-f135cebf9b87.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d63b0-0f91-76bf-96c8-f135cebf9b87",
        "storage_key": "property/6767906449167346/019d63b0-0f91-76bf-96c8-f135cebf9b87.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1S6bYVpjOIgRFRjeyRHR4W0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_8ecfecdb-ccda-43ff-bd2a-6755548a6706",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Meijer",
      "poi_type": "Shopping & Retail",
      "poi_address": "8300 Meijer Dr, Canal Winchester, OH 43110, USA",
      "poi_short_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_long_description": "People say this supermarket offers a wide variety of products, including groceries, clothes, shoes, jewelry, and pharmacy items, and has a great selection of garden plants and flowers. They also highlight the friendly and welcoming staff, and the clean and well-stocked store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d7918-8654-7727-950b-c544a9922609.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8654-7727-950b-c544a9922609",
        "storage_key": "property/6767906449167346/019d7918-8654-7727-950b-c544a9922609.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.meijer.com/shopping/store-locator/246.html?cmpid=LM:Web::::05112021::GoogleGrocery",
      "poi_directions_map_url": "https://maps.google.com/?cid=14852727250348886395&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meijer",
      "poi_latitude": "39.8492107",
      "poi_longitude": "-82.77722949999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-920-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0ff0-741c-a1c8-e4b66e5981b1.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63b0-0ff0-741c-a1c8-e4b66e5981b1",
        "storage_key": "property/6767906449167346/019d63b0-0ff0-741c-a1c8-e4b66e5981b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWel3UC16OIgRe0nPtr18H84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_3fd11ca7-7294-4dbf-b866-0cf07c0dd6f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2888 Brice Rd, Columbus, OH 43232, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of tools, materials, and home essentials. They also highlight the decent prices, helpful staff, and veteran discounts.\n\nOther reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-7c26-743f-9b01-4b210afa84a7.webp",
      "poi_featured_image_media": {
        "alt_text": "Lowe's logo on building exterior",
        "public_id": "019d63ad-7c26-743f-9b01-4b210afa84a7",
        "storage_key": "property/6767906449167346/019d63ad-7c26-743f-9b01-4b210afa84a7.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OH-Columbus/0003?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-3-_-na-_-0-_-0&y_source=1_MTE4MzcwMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2676719801172312673&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "39.921513",
      "poi_longitude": "-82.831328",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-575-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0f91-76bf-96c8-f135cebf9b87.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d63b0-0f91-76bf-96c8-f135cebf9b87",
        "storage_key": "property/6767906449167346/019d63b0-0f91-76bf-96c8-f135cebf9b87.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHSBAea18OIgRYUIhMHqeJSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_d5a731b2-2f49-46af-8eea-e34b459ddbc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Columbus Liquidation Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4141 Refugee Rd, Columbus, OH 43232, USA",
      "poi_short_description": "Furniture, appliances and building supplies offered at discount prices, including scratch-and-dent items.",
      "poi_long_description": "People say this home improvement store offers a vast selection of vanities, tiles, appliances, flooring, and cabinets. They highlight the reasonable prices, great deals, and the large inventory. They also like the helpful, friendly, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-9779-7549-a5a4-0fbdf4b5306e.webp",
      "poi_featured_image_media": {
        "alt_text": "Signage reading 'WATER HEATERS' above a display of water heaters.",
        "public_id": "019d63ad-9779-7549-a5a4-0fbdf4b5306e",
        "storage_key": "property/6767906449167346/019d63ad-9779-7549-a5a4-0fbdf4b5306e.webp",
        "width": 2313,
        "height": 3072
      },
      "poi_business_url": "https://clcliquidation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1706126195368703620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbus-liquidation-center",
      "poi_latitude": "39.9151039",
      "poi_longitude": "-82.88576499999999",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-966-4246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0f91-76bf-96c8-f135cebf9b87.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d63b0-0f91-76bf-96c8-f135cebf9b87",
        "storage_key": "property/6767906449167346/019d63b0-0f91-76bf-96c8-f135cebf9b87.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6UsFgqWFOIgRhLbwOLxgrRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_5071b2bc-c657-48a2-ab74-ba0e7dc5c40e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Columbus Metropolitan Library: Reynoldsburg Branch",
      "poi_type": "Education",
      "poi_address": "1402 Brice Rd, Reynoldsburg, OH 43068, USA",
      "poi_short_description": "Kid-friendly, chain-linked library with books, computers and printers, plus clean spaces.",
      "poi_long_description": "People say this public library offers a wide selection of books, spacious study rooms, and meeting rooms. They highlight the clean, well-maintained building, and the convenient location. They also like the friendly and helpful staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-b4bf-716b-b2d2-634f5940ad3c.webp",
      "poi_featured_image_media": {
        "alt_text": "Signage for Columbus Metropolitan Library, Reynoldsburg Branch",
        "public_id": "019d63ad-b4bf-716b-b2d2-634f5940ad3c",
        "storage_key": "property/6767906449167346/019d63ad-b4bf-716b-b2d2-634f5940ad3c.webp",
        "width": 1584,
        "height": 1224
      },
      "poi_business_url": "http://www.columbuslibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2391895907646539029&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbus-metropolitan-library-reynoldsburg-branch",
      "poi_latitude": "39.9516575",
      "poi_longitude": "-82.82812919999999",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 614-645-2275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0fe2-7199-aad8-d07e68021834.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d63b0-0fe2-7199-aad8-d07e68021834",
        "storage_key": "property/6767906449167346/019d63b0-0fe2-7199-aad8-d07e68021834.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG9Fs_2RjOIgRFYX7uqe4MSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b251c436-f04b-4187-bc1f-b3efcda07d66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Otherworld",
      "poi_type": "Entertainment",
      "poi_address": "5819 Chantry Dr, Columbus, OH 43232, USA",
      "poi_short_description": "Futuristic entertainment center with interactive puzzles, immersive rooms & digitally augmented art.",
      "poi_long_description": "People say this art museum offers a fascinating and immersive experience with different themed rooms and interactive art installations. They highlight the fun, creative, and unique atmosphere, and the opportunity to explore at one's own pace. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-b846-76a9-8991-30d3e152446e.webp",
      "poi_featured_image_media": {
        "alt_text": "Infinity room with glowing blue and pink lights, a vintage couch, and reflections.",
        "public_id": "019d63ad-b846-76a9-8991-30d3e152446e",
        "storage_key": "property/6767906449167346/019d63ad-b846-76a9-8991-30d3e152446e.webp",
        "width": 867,
        "height": 1300
      },
      "poi_business_url": "https://otherworld.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17421859372472758875&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "otherworld",
      "poi_latitude": "39.9221317",
      "poi_longitude": "-82.8360785",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-808-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-1035-7578-9e56-9d928a8100ea.webp",
      "poi_map_icon_media": {
        "alt_text": "Simple graphic icon of a building with the letter M inside.",
        "public_id": "019d63b0-1035-7578-9e56-9d928a8100ea",
        "storage_key": "property/6767906449167346/019d63b0-1035-7578-9e56-9d928a8100ea.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQzg4dZ9OIgRW3IMV8vgxvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_409acaf6-2969-4926-9712-12b5534c7b70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Magic Mountain Fun Center - East",
      "poi_type": "Entertainment",
      "poi_address": "5890 Scarborough Blvd, Columbus, OH 43232, USA",
      "poi_short_description": "Year-round, indoor/outdoor family fun center with mini-golf, go-karts, an arcade & batting cages.",
      "poi_long_description": "People say this amusement park offers a variety of attractions, including go-karts, mini golf, and an arcade, and is a fun place for birthday parties.\n\nOther reviews mention some games can be broken and the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-ed74-72cc-b029-4cc0baa7420c.webp",
      "poi_featured_image_media": {
        "alt_text": "Indoor playground with slides and tunnels.",
        "public_id": "019d63ad-ed74-72cc-b029-4cc0baa7420c",
        "storage_key": "property/6767906449167346/019d63ad-ed74-72cc-b029-4cc0baa7420c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.magicmountainfuncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8916092372920913817&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "magic-mountain-fun-center---east",
      "poi_latitude": "39.9320789",
      "poi_longitude": "-82.8343242",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 614-490-5071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ56byrU9jOIgRmU-FEMZSvHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_79b485c7-a9e9-4ec5-b4cd-a465b215b0c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "6314 E Livingston Ave, Reynoldsburg, OH 43068, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, a zip line, and a rock wall. They also highlight the friendly and helpful staff, and the clean and organized environment.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-baa9-76ae-9b8f-0929ef3a6260.webp",
      "poi_featured_image_media": {
        "alt_text": "Child climbing on a hanging obstacle in a neon-lit indoor adventure park.",
        "public_id": "019d63ad-baa9-76ae-9b8f-0929ef3a6260",
        "storage_key": "property/6767906449167346/019d63ad-baa9-76ae-9b8f-0929ef3a6260.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.urbanair.com/ohio-reynoldsburg/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=4515235319855976065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "39.9431905",
      "poi_longitude": "-82.8266299",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 614-739-1654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIRcstDtjOIgRgQ5QxZlWqT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_0cc9654a-e107-495e-b7f2-e1e2168f6d9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "AMA Motorcycle Hall of Fame Museum",
      "poi_type": "Entertainment",
      "poi_address": "13515 Yarmouth Dr, Pickerington, OH 43147, USA",
      "poi_short_description": "Small museum with exhibits on motorcycling heroes & the sport's evolution, plus iconic bikes.",
      "poi_long_description": "People say this motorcycle museum offers a wonderful selection of classic and unique motorcycles, including rare and important motorcycles for enthusiasts and historians. They highlight the reasonable price and the wide variety of motorcycles, especially those from visitors' youth. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-c9e5-7609-a3b2-eada77e9250e.webp",
      "poi_featured_image_media": {
        "alt_text": "Collection of vintage motorcycles with brand logos like Harley-Davidson, Honda, Suzuki, and Kawasaki on the wall.",
        "public_id": "019d63ad-c9e5-7609-a3b2-eada77e9250e",
        "storage_key": "property/6767906449167346/019d63ad-c9e5-7609-a3b2-eada77e9250e.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://americanmotorcyclist.com/hall-of-fame/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3372290453012043534&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ama-motorcycle-hall-of-fame-museum",
      "poi_latitude": "39.934113",
      "poi_longitude": "-82.78251399999999",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 614-856-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-1035-7578-9e56-9d928a8100ea.webp",
      "poi_map_icon_media": {
        "alt_text": "Simple graphic icon of a building with the letter M inside.",
        "public_id": "019d63b0-1035-7578-9e56-9d928a8100ea",
        "storage_key": "property/6767906449167346/019d63b0-1035-7578-9e56-9d928a8100ea.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJC0GPf9lkOIgRDlc5w0zIzC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b127250a-27d7-4bfb-8ca4-49b052ccb719",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Motts Military Museum, Inc.",
      "poi_type": "Entertainment",
      "poi_address": "5075 S Hamilton Rd, Groveport, OH 43125, USA",
      "poi_short_description": "Established in 1987, this not-for-profit museum features exhibits on U.S. military history, as well as live performances.",
      "poi_long_description": "Visitors say this museum is packed with military and Ohio history, featuring impressive vehicle displays. They also highlight the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ad-ce2c-7476-ab5e-72db06be8499.webp",
      "poi_featured_image_media": {
        "alt_text": "Motts Military Museum exterior with flags and parking lot.",
        "public_id": "019d63ad-ce2c-7476-ab5e-72db06be8499",
        "storage_key": "property/6767906449167346/019d63ad-ce2c-7476-ab5e-72db06be8499.webp",
        "width": 2560,
        "height": 1440
      },
      "poi_business_url": "https://mottsmilitarymuseuminc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15154580740420508798&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "motts-military-museum-inc",
      "poi_latitude": "39.8589124",
      "poi_longitude": "-82.88651089999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-836-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-1035-7578-9e56-9d928a8100ea.webp",
      "poi_map_icon_media": {
        "alt_text": "Simple graphic icon of a building with the letter M inside.",
        "public_id": "019d63b0-1035-7578-9e56-9d928a8100ea",
        "storage_key": "property/6767906449167346/019d63b0-1035-7578-9e56-9d928a8100ea.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3cuYcL19OIgRfpy9GOTiT9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8aeab9ff-f937-456c-abbd-2a5742a39b6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Crunch Fitness - Reynoldsburg",
      "poi_type": "Health and Wellness",
      "poi_address": "5929 E Main St, Columbus, OH 43232, USA",
      "poi_short_description": "Chain fitness center featuring personal trainers, group classes, and a \"no judgments\" philosophy.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio and strength training options, as well as tanning booths, UV beds, and a water chair massager. They also highlight the friendly and knowledgeable staff, the clean facility, and the positive and welcoming atmosphere.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-0fda-761e-b23d-e2fd0f533aca.webp",
      "poi_featured_image_media": {
        "alt_text": "Gym weight bench with weight plates loaded.",
        "public_id": "019d63ae-0fda-761e-b23d-e2fd0f533aca",
        "storage_key": "property/6767906449167346/019d63ae-0fda-761e-b23d-e2fd0f533aca.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.crunch.com/locations/reynoldsburg",
      "poi_directions_map_url": "https://maps.google.com/?cid=9023779112199295005&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---reynoldsburg",
      "poi_latitude": "39.9530424",
      "poi_longitude": "-82.841154",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-755-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4YIH3BjOIgRHZA64krnOn0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4c7d9ff3-cc2d-499a-9e33-43fb89858f4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "MedVet Diley Hill",
      "poi_type": "Health and Wellness",
      "poi_address": "9695 Basil Western Rd, Canal Winchester, OH 43110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d7918-86ab-77fa-a3cf-2373ab55fb9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-86ab-77fa-a3cf-2373ab55fb9b",
        "storage_key": "property/6767906449167346/019d7918-86ab-77fa-a3cf-2373ab55fb9b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.medvet.com/location/diley-hill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5867286963916400248&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "medvet-diley-hill",
      "poi_latitude": "39.8429335",
      "poi_longitude": "-82.7756466",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-829-6444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWMYeit6OIgReGaET2jKbFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_4ca1f5cc-b539-43e0-8b73-c8ee2e375c25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Jerry L. Garver YMCA - YMCA of Central Ohio",
      "poi_type": "Health and Wellness",
      "poi_address": "6767 Refugee Rd, Canal Winchester, OH 43110, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d7918-8655-75b8-bd87-b319f92eb8b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8655-75b8-bd87-b319f92eb8b3",
        "storage_key": "property/6767906449167346/019d7918-8655-75b8-bd87-b319f92eb8b3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://ymcacolumbus.org/locations/garver?utm_source=google_business_profile&utm_medium=Organic&utm_campaign=gbp_garver",
      "poi_directions_map_url": "https://maps.google.com/?cid=16179460607339324314&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jerry-l-garver-ymca---ymca-of-central-ohio",
      "poi_latitude": "39.90925",
      "poi_longitude": "-82.8192441",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-389-4556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5JlYFh7OIgRmuPiLbP9iOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_51e332c7-4c38-4bf9-bd77-9f44913a3635",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6591 Winchester Blvd, Canal Winchester, OH 43110, USA",
      "poi_short_description": "Gym (part of a chain) with friendly staff, clean facilities, tanning beds and treadmills.",
      "poi_long_description": "People say this gym offers a nice selection of cardio and strength training equipment. They also highlight the clean environment, friendly staff, and convenient location.\n\nOther reviews mention the equipment can be unavailable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-0de9-760b-95a6-703f551163d4.webp",
      "poi_featured_image_media": {
        "alt_text": "A busy gym with various exercise machines and people working out.",
        "public_id": "019d63ae-0de9-760b-95a6-703f551163d4",
        "storage_key": "property/6767906449167346/019d63ae-0de9-760b-95a6-703f551163d4.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/canal-winchester-oh?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17259035513430898149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.852712",
      "poi_longitude": "-82.82561009999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-833-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb1yugh8OIgR5XXmb1tphO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dde077fb-6aab-4590-bfee-191a0cd48edc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1520 Stonecreek Dr S, Pickerington, OH 43147, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of fun fitness classes, amazing knowledgeable trainers, and a clean facility with top-notch equipment. They also highlight the friendly and helpful staff, and the convenient childcare services.\n\nSome reviews mention the gym can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-3b7d-71aa-b290-80693f4645d6.webp",
      "poi_featured_image_media": {
        "alt_text": "Lifetime Fitness building exterior with large windows and prominent signage.",
        "public_id": "019d63ae-3b7d-71aa-b290-80693f4645d6",
        "storage_key": "property/6767906449167346/019d63ae-3b7d-71aa-b290-80693f4645d6.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/oh/pickerington.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=1453119964598497811&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "39.915811",
      "poi_longitude": "-82.7833331",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 614-759-8593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhashACx7OIgRE_LrqeiEKhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f975a5a5-c0a1-4572-b47a-690d3080b814",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "American Barbell Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "9099 Basil Western Rd, Canal Winchester, OH 43110, USA",
      "poi_short_description": "Clean 24-hour fitness center featuring free weights, equipment variety and attentive staff.",
      "poi_long_description": "People say this gym offers a wide variety of top-quality equipment from major brands, catering to various training styles. They highlight the spacious, clean, and well-maintained facilities, as well as the friendly and helpful staff. They also like the welcoming and supportive atmosphere, and the additional amenities such as cold plunges, saunas, and a basketball court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-6d8a-74fd-b230-90e0124c9587.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a gym with rows of dumbbells and weight benches.",
        "public_id": "019d63ae-6d8a-74fd-b230-90e0124c9587",
        "storage_key": "property/6767906449167346/019d63ae-6d8a-74fd-b230-90e0124c9587.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.americanbarbellohio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7384820995425982851&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "american-barbell-athletic-club",
      "poi_latitude": "39.8424263",
      "poi_longitude": "-82.7640991",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-828-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdZrKxx7OIgRg1k2opEnfGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b7c74aa4-0115-41fa-8f76-ca1139859b7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Columbus Gymnastics Academy",
      "poi_type": "Health and Wellness",
      "poi_address": "6810 Thrush Dr, Canal Winchester, OH 43110, USA",
      "poi_short_description": "Long-running center for kids' gymnastics classes, with a friendly team.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-9f27-700c-babc-e9ba772971fb.webp",
      "poi_featured_image_media": {
        "alt_text": "Children playing with a parachute in a gym.",
        "public_id": "019d63ae-9f27-700c-babc-e9ba772971fb",
        "storage_key": "property/6767906449167346/019d63ae-9f27-700c-babc-e9ba772971fb.webp",
        "width": 1932,
        "height": 2576
      },
      "poi_business_url": "https://cgagymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14517031161514665837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbus-gymnastics-academy",
      "poi_latitude": "39.8429794",
      "poi_longitude": "-82.8222018",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-575-9557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0fe2-7199-aad8-d07e68021834.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d63b0-0fe2-7199-aad8-d07e68021834",
        "storage_key": "property/6767906449167346/019d63b0-0fe2-7199-aad8-d07e68021834.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1cNona5kOIgRbadbR-3adsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a87faa72-1448-4d91-8fc9-d69a29e40482",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Mago’s Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "5206 E Main St, Whitehall, OH 43213, USA",
      "poi_short_description": "Spanish-speaking barbershop offering haircuts and shaves in an upbeat environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-6df2-72ce-b519-f3d8081525ab.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a barber shop with rows of barber chairs and stations.",
        "public_id": "019d63ae-6df2-72ce-b519-f3d8081525ab",
        "storage_key": "property/6767906449167346/019d63ae-6df2-72ce-b519-f3d8081525ab.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4288525113374410442&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "magos-barbershop",
      "poi_latitude": "39.9555473",
      "poi_longitude": "-82.8603744",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-762-2778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNS8gsS9jOIgRygYGed7mgzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_ce196c91-1083-45f7-a735-d1a35f06f498",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "OhioHealth Pickerington Methodist Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1010 Refugee Rd, Pickerington, OH 43147, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-c29f-769d-bb7a-498d37d21311.webp",
      "poi_featured_image_media": {
        "alt_text": "Reception area with seating and artwork displayed.",
        "public_id": "019d63ae-c29f-769d-bb7a-498d37d21311",
        "storage_key": "property/6767906449167346/019d63ae-c29f-769d-bb7a-498d37d21311.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.ohiohealth.com/locations/hospitals/pickerington-methodist-hospital?utm_source=yext&utm_medium=listings&utm_campaign=websiteclicksfacility",
      "poi_directions_map_url": "https://maps.google.com/?cid=12047586481793860127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ohiohealth-pickerington-methodist-hospital",
      "poi_latitude": "39.9121836",
      "poi_longitude": "-82.7830389",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 614-788-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0fe8-720f-adfb-06fe465a5e1b.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d63b0-0fe8-720f-adfb-06fe465a5e1b",
        "storage_key": "property/6767906449167346/019d63b0-0fe8-720f-adfb-06fe465a5e1b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJidcznyh7OIgRHwIfCBOgMac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2ddf7c04-76b1-41fb-9793-161b53e83619",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Diley Ridge Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "7911 Diley Rd, Canal Winchester, OH 43110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-94aa-71dd-8cde-002158ec1116.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a modern medical building with an emergency entrance.",
        "public_id": "019d63ae-94aa-71dd-8cde-002158ec1116",
        "storage_key": "property/6767906449167346/019d63ae-94aa-71dd-8cde-002158ec1116.webp",
        "width": 1778,
        "height": 1000
      },
      "poi_business_url": "https://www.mountcarmelhealth.com/location/diley-ridge-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=4974802256447283198&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "diley-ridge-medical-center",
      "poi_latitude": "39.8505543",
      "poi_longitude": "-82.7840983",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-838-7911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0fe8-720f-adfb-06fe465a5e1b.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d63b0-0fe8-720f-adfb-06fe465a5e1b",
        "storage_key": "property/6767906449167346/019d63b0-0fe8-720f-adfb-06fe465a5e1b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3YC1ms17OIgR_h9aa0sMCkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_198a808a-3df3-4b13-ada3-9ca79c32d81b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Blacklick Woods Metro Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6975 E Livingston Ave, Reynoldsburg, OH 43068, USA",
      "poi_short_description": "Popular, 643-acre park featuring wooded trails, wildlife sightings, picnic areas & other activities.",
      "poi_long_description": "Visitors say this metro park offers a canopy walk, nature center, walking trails, and picnic areas. They also highlight that it's a great place for exercise, enjoying nature, and spending time with family and friends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d7918-a07b-75ac-8be4-45bac8c77e62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-a07b-75ac-8be4-45bac8c77e62",
        "storage_key": "property/6767906449167346/019d7918-a07b-75ac-8be4-45bac8c77e62.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.metroparks.net/parks-and-trails/blacklick-woods/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2958743023453128471&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blacklick-woods-metro-park",
      "poi_latitude": "39.9362001",
      "poi_longitude": "-82.8099763",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-861-8759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-103c-7498-89ab-1d99522f40b0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d63b0-103c-7498-89ab-1d99522f40b0",
        "storage_key": "property/6767906449167346/019d63b0-103c-7498-89ab-1d99522f40b0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_EI6L5kOIgRF8eWjhqRDyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_36eb1c0f-7600-4886-a704-60be1c2f88ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Blacklick Woods Canopy Walk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6711 E Livingston Ave, Reynoldsburg, OH 43068, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this hiking area offers a fun canopy walk with rope bridges, a nature center, and plenty of parking. They also highlight the handicap accessibility, beautiful views, and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-d696-73fc-8740-cf47417bd874.webp",
      "poi_featured_image_media": {
        "alt_text": "People walking on a scenic elevated boardwalk through a lush forest.",
        "public_id": "019d63ae-d696-73fc-8740-cf47417bd874",
        "storage_key": "property/6767906449167346/019d63ae-d696-73fc-8740-cf47417bd874.webp",
        "width": 1638,
        "height": 2048
      },
      "poi_business_url": "http://www.metroparks.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5221716705831415481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blacklick-woods-canopy-walk",
      "poi_latitude": "39.9337273",
      "poi_longitude": "-82.8069628",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 614-208-4247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQblVwBlOIgRue7NmK1Dd0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_0b6e75c7-ea8a-4a75-994a-13769c8f1ed0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Blacklick Woods Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7309 E Livingston Ave, Reynoldsburg, OH 43068, USA",
      "poi_short_description": "Golf course featuring an 18-hole course & a 9-hole course, plus a pro shop & a practice area.",
      "poi_long_description": "People say this golf course offers a challenging 18-hole course, a beginner-friendly 9-hole course, and a driving range. They also highlight the great prices, especially for Franklin County residents, and the beautiful, natural setting.\n\nOther reviews mention the course conditions can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d7918-9bed-75ad-bb26-b6d372bd35f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-9bed-75ad-bb26-b6d372bd35f4",
        "storage_key": "property/6767906449167346/019d7918-9bed-75ad-bb26-b6d372bd35f4.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://blacklickwoodsgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12719615141122306745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blacklick-woods-golf-course",
      "poi_latitude": "39.9426962",
      "poi_longitude": "-82.802038",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-861-3193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0fda-75dd-aaee-b3aec2e7cd22.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a person playing soccer",
        "public_id": "019d63b0-0fda-75dd-aaee-b3aec2e7cd22",
        "storage_key": "property/6767906449167346/019d63b0-0fda-75dd-aaee-b3aec2e7cd22.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJl8qQlpVkOIgRuXJGVpQmhbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_a1e7b9c2-06e7-412f-8fda-34985d13b92d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Three Creeks Metro Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3860 Bixby Rd, Groveport, OH 43125, USA",
      "poi_short_description": "This sizable park with trails, sports facilities & dog areas also offers fishing, boating & more.",
      "poi_long_description": "People say this park offers paved trails, bike trails, and off-trail exploration. They highlight the beautiful scenery, the variety of trails, and the peaceful atmosphere. They also like the amenities, such as picnic shelters, playgrounds, and a fishing pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d7918-a060-746d-9825-7809356e4d73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-a060-746d-9825-7809356e4d73",
        "storage_key": "property/6767906449167346/019d7918-a060-746d-9825-7809356e4d73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metroparks.net/ParksThreeCreeks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=18099784680095834721&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "three-creeks-metro-park",
      "poi_latitude": "39.88030800000001",
      "poi_longitude": "-82.9035188",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 614-409-9914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-103c-7498-89ab-1d99522f40b0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d63b0-103c-7498-89ab-1d99522f40b0",
        "storage_key": "property/6767906449167346/019d63b0-103c-7498-89ab-1d99522f40b0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc07WsmSHOIgRYWIrEEVaL_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_10a57b41-5890-494d-aa86-076eee0bbe2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Turnberry Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1145 Clubhouse Ln, Pickerington, OH 43147, USA",
      "poi_short_description": "Public golf facility featuring several lakes, numerous bunkers & lessons for adults & kids.",
      "poi_long_description": "Public golf facility featuring several lakes, numerous bunkers & lessons for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d7918-a388-71ad-912a-942f600c4076.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-a388-71ad-912a-942f600c4076",
        "storage_key": "property/6767906449167346/019d7918-a388-71ad-912a-942f600c4076.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://crpdgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5402108706925123337&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "turnberry-golf-course",
      "poi_latitude": "39.9220632",
      "poi_longitude": "-82.7859232",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-645-2582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0fda-75dd-aaee-b3aec2e7cd22.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a person playing soccer",
        "public_id": "019d63b0-0fda-75dd-aaee-b3aec2e7cd22",
        "storage_key": "property/6767906449167346/019d63b0-0fda-75dd-aaee-b3aec2e7cd22.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ3PoNjN7OIgRCRdRUj8l-Eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_140c50b2-ff23-4a67-b6d7-0a9abc5386e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Shiseido OH",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5271 Centerpoint Pkwy, Groveport, OH 43125, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63ae-f960-73fa-9a13-6c9c925696bc.webp",
      "poi_featured_image_media": {
        "alt_text": "Industrial building with multiple loading docks and trucks parked outside.",
        "public_id": "019d63ae-f960-73fa-9a13-6c9c925696bc",
        "storage_key": "property/6767906449167346/019d63ae-f960-73fa-9a13-6c9c925696bc.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1209738380468919602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shiseido-oh",
      "poi_latitude": "39.8533007",
      "poi_longitude": "-82.9277031",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-446-1905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrQeNkFOHOIgRMp0Bx6XayRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4cce8093-86fb-4596-bcec-151fba493470",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Forward Air Guard Shack",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6750 Port Rd, Groveport, OH 43125, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11111329420891695480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "forward-air-guard-shack",
      "poi_latitude": "39.832318",
      "poi_longitude": "-82.9239774",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK26yzL6AOIgReKmY6jxfM5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dc292cec-f13f-466c-b934-198d70915819",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "Pickerington City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Lockville Rd, Pickerington, OH 43147, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-1ef4-73d9-a394-07521c14a4da.webp",
      "poi_featured_image_media": {
        "alt_text": "Pickerington City Hall building exterior with brick facade and white columns.",
        "public_id": "019d63af-1ef4-73d9-a394-07521c14a4da",
        "storage_key": "property/6767906449167346/019d63af-1ef4-73d9-a394-07521c14a4da.webp",
        "width": 568,
        "height": 396
      },
      "poi_business_url": "http://pickerington.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16383996695845973096&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pickerington-city-hall",
      "poi_latitude": "39.8819466",
      "poi_longitude": "-82.7519215",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-837-3974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0fe9-7649-8a70-75cb42f41e6e.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d63b0-0fe9-7649-8a70-75cb42f41e6e",
        "storage_key": "property/6767906449167346/019d63b0-0fe9-7649-8a70-75cb42f41e6e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZc5c6ot6OIgRaKwSUTCmX-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_ee5351b0-60f6-4067-b00e-65b0aa304012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "City of Canal Winchester City Hall/ Municipal Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "45 E Waterloo St, Canal Winchester, OH 43110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-3859-77d0-a088-485c9a18c076.webp",
      "poi_featured_image_media": {
        "alt_text": "Entrance to Canal Winchester City Hall with brick facade and large glass doors.",
        "public_id": "019d63af-3859-77d0-a088-485c9a18c076",
        "storage_key": "property/6767906449167346/019d63af-3859-77d0-a088-485c9a18c076.webp",
        "width": 1614,
        "height": 1033
      },
      "poi_business_url": "http://www.canalwinchesterohio.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10585027330507241653&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-canal-winchester-city-hall-municipal-building",
      "poi_latitude": "39.8419161",
      "poi_longitude": "-82.80418580000001",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-837-7493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-0fe9-7649-8a70-75cb42f41e6e.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d63b0-0fe9-7649-8a70-75cb42f41e6e",
        "storage_key": "property/6767906449167346/019d63b0-0fe9-7649-8a70-75cb42f41e6e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ112OP-J7OIgRtXivdEaS5ZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_8d4e021d-afdc-4573-9fa3-efb67bcafa25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "poi_name": "R G Barry Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13405 Yarmouth Dr, Pickerington, OH 43147, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-386c-753b-bff0-46a177e1e719.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a modern white building with a flagpole and two flags.",
        "public_id": "019d63af-386c-753b-bff0-46a177e1e719",
        "storage_key": "property/6767906449167346/019d63af-386c-753b-bff0-46a177e1e719.webp",
        "width": 2833,
        "height": 1814
      },
      "poi_business_url": "http://www.rgbarry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16329508872707555675&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "r-g-barry-corporation",
      "poi_latitude": "39.9315242",
      "poi_longitude": "-82.7842685",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-864-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b0-110f-7409-97b5-e737b8f25d86",
        "storage_key": "property/6767906449167346/019d63b0-110f-7409-97b5-e737b8f25d86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4f9C9pkOIgRW8FSYs0RnuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f35632bc-cf07-4b71-a421-9fd711ffe712",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bbc11c0b-79fe-4321-acb2-9c738dbcff3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_40b38cda-0305-4b08-8fea-98dbd64b3fb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1861cf52-0487-4c07-9a16-eef3fd777f47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f34303e3-049d-4d41-9c92-04993266ee02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_88777b4f-8379-4284-8d9c-e2cda8d3b22c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "rating": "5.0",
      "name": "Tonio B",
      "text": "Steven from maintenance was awesome. He went above and beyond to make sure things were taken care of the first time. Give that man a raise",
      "date": "2026-01-29",
      "title": ""
    },
    {
      "id": "custom_3aea099c-7438-42a2-ac51-66e05da3c745",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "rating": "5.0",
      "name": "Abdul Nasir Abubakar",
      "text": "The apartments are nice.....and it’s a decent neighborhood....the management is great. Aisha is like a sister to me she put all her effort into the apartment just for her two big brothers to get it. She’s been so caring, loving and attentive. Thank you sissy ❤️✌️",
      "date": "2025-05-28",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_92502ee0f5d32e9145de0638",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-b47b-765f-a248-7b668a5ac066.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d63af-b47b-765f-a248-7b668a5ac066",
        "storage_key": "property/6767906449167346/019d63af-b47b-765f-a248-7b668a5ac066.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubroom",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FGDq27Wmw8y"
    },
    {
      "id": "ec_808fb311e52186ebdab0cb75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-b3db-76bb-8591-e424f9c37c50.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d63af-b3db-76bb-8591-e424f9c37c50",
        "storage_key": "property/6767906449167346/019d63af-b3db-76bb-8591-e424f9c37c50.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4GSa6EAc2So"
    },
    {
      "id": "ec_f57957e62314d0e9c0722611",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-b379-71cf-8674-3450502d6663.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d63af-b379-71cf-8674-3450502d6663",
        "storage_key": "property/6767906449167346/019d63af-b379-71cf-8674-3450502d6663.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 816 SF - York",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zpj3ZeATVjo"
    },
    {
      "id": "ec_0faa10371502eb9ee1685a1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-b30b-7318-9a3c-7ef6cc679b12.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d63af-b30b-7318-9a3c-7ef6cc679b12",
        "storage_key": "property/6767906449167346/019d63af-b30b-7318-9a3c-7ef6cc679b12.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 1,022 SF - Ashbrook",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QtDc8J3jj36"
    },
    {
      "id": "ec_c970f2d350e09139f806c88b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-b479-74ef-a3b5-f1a957538bb5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d63af-b479-74ef-a3b5-f1a957538bb5",
        "storage_key": "property/6767906449167346/019d63af-b479-74ef-a3b5-f1a957538bb5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 1,022 SF - Ashbrook",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ooHLB68cj9i"
    },
    {
      "id": "ec_17da2b887582bc7c8a6bdabb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63af-b32c-76fc-a0e6-dd4b3e89e621.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d63af-b32c-76fc-a0e6-dd4b3e89e621",
        "storage_key": "property/6767906449167346/019d63af-b32c-76fc-a0e6-dd4b3e89e621.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - York",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eQnLfd3Vn6S"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e1ddc-6096-767d-882d-1ede40e30f21",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "ara---ashbrook-run-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346"
    },
    {
      "lead_collector_id": "019e1ddc-610f-702b-93cb-0135e141c863",
      "lead_source": "FACEBOOK_ADS",
      "name": "ara---ashbrook-run-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346"
    },
    {
      "lead_collector_id": "019e1ddc-6182-7621-9b0c-de259b848913",
      "lead_source": "LANDING_PAGE",
      "name": "ara---ashbrook-run-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-canal-winchester-oh",
      "search_query": "pet friendly apartments Canal Winchester OH",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Canal Winchester",
      "h2_subtitle": "Discover pet-friendly living in Canal Winchester, OH. Ashbrook Run Apartments welcomes you and your furry friends with open arms.",
      "page_copy": "At Ashbrook Run Apartments, we understand that pets are loved. Nestled in the serene community of Canal Winchester, OH, our pet-friendly apartments are designed with both you and your furry companions in mind. Enjoy spacious floor plans that offer plenty of room for play, and take advantage of our community's welcoming attitude towards pets. From upgraded townhouses featuring keyless entry to on-site maintenance that handles all your needs, every detail is crafted for convenience.\n\nExperience the difference of living in a community that cares. Our pet-friendly apartments in Canal Winchester, OH, not only provide stylish patios perfect for lounging but also offer essential amenities like 24-hour emergency services and in-home washer/dryer options. Whether you're taking a leisurely walk around the neighborhood at Schirm Farm or relaxing at home with modern comforts, Ashbrook Run Apartments ensures you and your pets feel right at home. Schedule a tour today and see the pet-friendly lifestyle waiting for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Living in Canal Winchester",
      "seo_description": "Discover pet-friendly apartments at Ashbrook Run in Canal Winchester, OH. Spacious, modern, and welcoming to furry friends. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-washer-dryer-canal-winchester",
      "search_query": "apartments with in-unit washer dryer Canal Winchester",
      "category": "Amenity",
      "h1_title": "Canal Winchester Apartments with In-Unit Laundry",
      "h2_subtitle": "Convenience meets comfort in Canal Winchester with our in-unit washer and dryer apartments. Experience Ashbrook Run today!",
      "page_copy": "Ashbrook Run Apartments offers a seamless blend of convenience and comfort in Canal Winchester, OH. Our apartments with in-unit washer and dryer options provide the ultimate ease for busy residents. No more trips to the laundromat—enjoy the luxury of taking care of laundry from the comfort of your own home. Our open and spacious floor plans are designed to accommodate your lifestyle needs, ensuring you have the perfect setting for both relaxation and productivity.\n\nLocated in the charming neighborhood of Schirm Farm, Ashbrook Run not only offers modern in-home amenities, but also onsite benefits such as keyless entry and 24-hour emergency maintenance. Our community is pet-friendly, making it an ideal choice for those with furry family members. With all these conveniences, why wait? Discover the comfort of our Canal Winchester apartments with in-unit washer and dryer and schedule a tour today—you’ll love where you live!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenience with In-Unit Laundry at Ashbrook Run",
      "seo_description": "Discover Ashbrook Run Apartments in Canal Winchester with in-unit washer and dryer. Enjoy modern comforts and schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "spacious-floor-plans-apartment-franklin-county",
      "search_query": "spacious floor plans apartment Franklin County",
      "category": "Amenity",
      "h1_title": "Spacious Apartments in Franklin County",
      "h2_subtitle": "Explore our spacious floor plans in Franklin County. Ashbrook Run Apartments offers room to grow and thrive in Canal Winchester.",
      "page_copy": "Discover a vibrant lifestyle at Ashbrook Run Apartments, where spacious floor plans in Franklin County redefine comfort. Our Canal Winchester community ensures that you have ample room to grow, relax, and thrive. Each apartment is thoughtfully designed to provide generous living spaces, making it easy to create a home that reflects your personal style. Whether you’re looking to entertain guests or enjoy quiet nights, our floor plans accommodate every need.\n\nSituated in the picturesque Schirm Farm neighborhood, Ashbrook Run boasts more than just a place to live. Our townhouses feature the latest in modern conveniences, including keyless entry and 24hr emergency maintenance, ensuring a hassle-free living experience. Enjoy the added benefits of stylish patios and in-home laundry options for an unmatched level of comfort. Experience the spacious living you desire in Franklin County by scheduling a visit with us today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Floor Plans in Franklin County",
      "seo_description": "Find spacious floor plans at Ashbrook Run Apartments in Franklin County. Experience comfort and style in Canal Winchester—schedule a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "apartments-with-central-air-conditioning-schirm-farm",
      "search_query": "apartments with central air conditioning Schirm Farm",
      "category": "Amenity",
      "h1_title": "Schirm Farm Apartments with Central Air",
      "h2_subtitle": "Stay cool and comfortable in Schirm Farm. Discover Ashbrook Run Apartments with central air conditioning in Canal Winchester.",
      "page_copy": "At Ashbrook Run Apartments, staying comfortable has never been easier. Step into our modern community located in the heart of Schirm Farm, where each apartment is equipped with central air conditioning. Enjoy consistent comfort throughout the seasons, making every day in Canal Winchester, OH a pleasure. Our apartments are designed to offer not just comfort but also enhance your lifestyle with an array of amenities.\n\nLocated within the serene Schirm Farm neighborhood, Ashbrook Run marries convenience with style. Our spacious townhouses feature keyless entry and in-unit laundry options, complemented by features like stylish patios perfect for relaxation. Plus, with our pet-friendly policy and 24-hour emergency maintenance, we cater to all your needs. Schedule a tour today and experience the perfect blend of comfort and modernity at Ashbrook Run Apartments, where central air conditioning is just one of the many perks.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Central Air Apartments at Schirm Farm",
      "seo_description": "Discover cool comfort at Ashbrook Run Apartments with central air in Schirm Farm. Enjoy modern amenities and spacious living—visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "24hr-maintenance-apartments-canal-winchester-43110",
      "search_query": "24hr maintenance apartments Canal Winchester 43110",
      "category": "Amenity",
      "h1_title": "24hr Maintenance Apartments in Canal Winchester",
      "h2_subtitle": "Discover reliable 24hr maintenance at Ashbrook Run Apartments. Located in Canal Winchester 43110, enjoy hassle-free living today.",
      "page_copy": "Welcome to Ashbrook Run Apartments, the epitome of hassle-free living in Canal Winchester, OH. Our community proudly offers 24hr maintenance services, ensuring peace of mind round the clock. Whether it's a small fix or an emergency, our dedicated team is ready to address your needs promptly, providing reliable support whenever you need it. Located in the welcoming Schirm Farm neighborhood, our apartments are designed to offer both comfort and convenience.\n\nAshbrook Run's townhouses are modern and designed with resident satisfaction in mind. Enjoy features like keyless entry, stylish patios, and spacious floor plans that suit a variety of lifestyles. With pet-friendly policies and in-unit laundry options, our community meets all your everyday needs with ease. Experience the difference that responsive 24-hour maintenance and thoughtful design can make by scheduling a visit to Ashbrook Run Apartments, the premier choice for convenient living in Canal Winchester.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24hr Maintenance at Ashbrook Run, Canal Winchester",
      "seo_description": "Enjoy 24hr maintenance at Ashbrook Run Apartments in Canal Winchester 43110. Experience hassle-free living with modern conveniences today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-schirm-farm",
      "search_query": "two bedroom apartments Schirm Farm",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Schirm Farm",
      "h2_subtitle": "Discover spacious two bedroom apartments at Ashbrook Run. Located in the heart of Schirm Farm, enjoy modern amenities and comfort.",
      "page_copy": "Explore the perfect blend of space and style at Ashbrook Run Apartments in Schirm Farm. Our two bedroom apartments are designed to offer ample living space coupled with modern conveniences, providing an inviting sanctuary in Canal Winchester, OH. Each unit features well-thought-out layouts that make it easy to relax and entertain, making Ashbrook Run the ideal choice for those seeking more room for work-from-home setups.\n\nSituated in the charming Schirm Farm neighborhood, Ashbrook Run Apartments not only offer practical amenities but also elevate your living experience. Enjoy features such as keyless entry, private patios, and in-unit laundry options. Our pet-friendly community ensures that everyone feels at home, while our engaging neighborhood location provides plenty of local charm. Discover the benefits of spacious living and schedule a tour to view our two bedroom offerings today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Schirm Farm",
      "seo_description": "Explore spacious two bedroom apartments at Ashbrook Run in Schirm Farm. Discover modern living with ample amenities in Canal Winchester!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-canal-winchester-oh",
      "search_query": "one bedroom apartments Canal Winchester OH",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Canal Winchester, OH",
      "h2_subtitle": "Find your new home in Canal Winchester with Ashbrook Run's one bedroom apartments. Modern amenities and comfort await you.",
      "page_copy": "Discover the convenience and comfort of one bedroom apartments at Ashbrook Run Apartments in Canal Winchester, OH. Perfectly designed for individuals or couples, our apartments provide a cozy yet spacious living environment. Each one bedroom unit is optimized for comfort and practicality, featuring modern finishes that suit a variety of lifestyles.\n\nLocated in the serene Schirm Farm neighborhood, Ashbrook Run combines modern-day conveniences with stylish living. Enjoy amenities like keyless entry, private patios, and washer/dryer options that make daily life a breeze. Plus, with our pet-friendly policy and attentive 24-hour maintenance, we ensure every resident and their furry friends feel at home. Visit Ashbrook Run Apartments to discover your ideal one bedroom apartment in Canal Winchester today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Canal Winchester, OH",
      "seo_description": "Explore one bedroom apartments at Ashbrook Run in Canal Winchester, OH. Experience modern living with convenient amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "apartments-near-ohiohealth-pickerington-methodist-hospital",
      "search_query": "apartments near OhioHealth Pickerington Methodist Hospital Canal Winchester",
      "category": "Hospital",
      "h1_title": "Apartments Near OhioHealth Pickerington Hospital",
      "h2_subtitle": "Conveniently located near OhioHealth Pickerington Methodist Hospital, Ashbrook Run Apartments offer comfort and modern living in Canal Winchester.",
      "page_copy": "Looking for a home close to OhioHealth Pickerington Methodist Hospital? Ashbrook Run Apartments in Canal Winchester, OH, offers the perfect location for healthcare professionals and hospital visitors alike. Our community provides easy access to the hospital, combined with the comfort of modern living in a serene setting. Whether you're commuting for work or seeking proximity to medical facilities, Ashbrook Run is an ideal choice.\n\nNestled in the inviting Schirm Farm area, our apartments feature practical amenities such as keyless entry, private patios, and spacious layouts. In addition, we offer 24-hour maintenance services, ensuring a worry-free living experience for all our residents. Enjoy the convenience of nearby healthcare facilities without sacrificing the peace and lifestyle you desire. Visit Ashbrook Run Apartments today and discover how close-knit community living can complement your needs near OhioHealth Pickerington Methodist Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OhioHealth Pickerington Hospital",
      "seo_description": "Find apartments near OhioHealth Pickerington Methodist Hospital at Ashbrook Run in Canal Winchester. Experience convenience and comfort today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "ashbrook-run-close-to-diley-ridge-medical-center",
      "search_query": "Ashbrook Run living close to Diley Ridge Medical Center",
      "category": "Hospital",
      "h1_title": "Ashbrook Run: Near Diley Ridge Medical Center",
      "h2_subtitle": "Experience the ease of living at Ashbrook Run Apartments, conveniently located near Diley Ridge Medical Center in Canal Winchester.",
      "page_copy": "Ashbrook Run Apartments offer the ideal living situation for those needing proximity to Diley Ridge Medical Center. Perfectly situated in Canal Winchester, our community combines convenience with comfortable living. Whether you work at the medical center or seek easy access to healthcare services, our prime location offers unmatched accessibility without compromising on lifestyle.\n\nNestled in the peaceful Schirm Farm neighborhood, Ashbrook Run Apartments provide modern amenities like keyless entry, inviting patios, and spacious floor plans. Our pet-friendly policy and top-notch maintenance services further enhance the living experience, making it a favorite among residents. Embrace the convenience of living close to Diley Ridge Medical Center and enjoy a vibrant and relaxed community at Ashbrook Run. Schedule a visit today and see firsthand how our location can benefit your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ashbrook Run: Near Diley Ridge Medical Center",
      "seo_description": "Live near Diley Ridge Medical Center at Ashbrook Run Apartments. Enjoy convenience and modern amenities in Canal Winchester.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "apartments-near-blacklick-woods-metro-park-canal-winchester",
      "search_query": "apartments near blacklick woods metro park canal winchester",
      "category": "Park",
      "h1_title": "Apartments Near Blacklick Woods Metro Park",
      "h2_subtitle": "Discover Ashbrook Run Apartments, conveniently located near Blacklick Woods Metro Park in Canal Winchester, OH.",
      "page_copy": "Experience the beauty of nature combined with modern living at Ashbrook Run Apartments, located near Blacklick Woods Metro Park in Canal Winchester, OH. Enjoy the best of both worlds—tranquil outdoor spaces and contemporary apartment amenities that cater to a variety of lifestyles. Situated just a short drive from the park, our community is perfect for outdoor enthusiasts who desire easy access to hiking and nature trails.\n\nAshbrook Run offers residents spacious floor plans, keyless entry, and private patios. Our pet-friendly apartments ensure that your furry friends, feels at home. With the added convenience of 24-hour emergency maintenance, residents can live worry-free while enjoying proximity to one of the area's most cherished natural spaces. Discover the ideal blend of convenience and serenity by visiting Ashbrook Run Apartments today, your gateway to Blacklick Woods Metro Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Blacklick Woods Metro Park",
      "seo_description": "Explore apartments near Blacklick Woods Metro Park at Ashbrook Run in Canal Winchester. Enjoy nature and modern living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167346",
      "source": "custom",
      "page_item_url": "apartments-close-to-three-creeks-metro-park-franklin-county",
      "search_query": "apartments close to three creeks metro park franklin county",
      "category": "Park",
      "h1_title": "Apartments Near Three Creeks Metro Park",
      "h2_subtitle": "Live close to nature at Ashbrook Run Apartments, conveniently near Three Creeks Metro Park in Franklin County.",
      "page_copy": "Situated in the heart of Franklin County, Ashbrook Run Apartments offer a serene living experience just minutes away from Three Creeks Metro Park. Ideal for nature lovers and outdoor enthusiasts, our community provides easy access to the park's extensive trails, picnic areas, and scenic woods. Embrace the tranquility of park-side living with the convenience of modern amenities.\n\nOur Canal Winchester community features spacious townhouses equipped with keyless entry, stylish patios, and available in-home washers and dryers. With pet-friendly policies and 24-hour emergency maintenance, Ashbrook Run is designed to meet the varied needs of our residents. Experience the seamless blend of natural beauty and contemporary comfort—visit Ashbrook Run Apartments today and discover why we're a top choice for those seeking proximity to Three Creeks Metro Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the property's building entrance with brick and stone facade, flanked by manicured bushes and trees.",
        "public_id": "019d63b5-9bd7-71ad-bf86-7505ad223b40",
        "storage_key": "property/6767906449167346/019d63b5-9bd7-71ad-bf86-7505ad223b40.webp",
        "width": 1284,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Three Creeks Metro Park",
      "seo_description": "Discover apartments near Three Creeks Metro Park at Ashbrook Run in Franklin County. Enjoy park-side living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6277"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11680150098"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4059828"
    },
    {
      "ID": "custom_adtaxi_domain",
      "type": "STRING",
      "value": "https://tags.tiqcdn.com/utag/adtaxi-pm/ashbrookrun.com/prod/utag.js"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MTMP3WN2"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "5811ed2102a530a6"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "c0c85c72a64e11edbd41023423a61a29"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "614-714-5083"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjlzdVQ4SjdiMUhEU2dWUllSNDI4cFE9PSIsInZhbHVlIjoiemltZ1hLcGM3NlB1MDRNZDZPYzI5dz09IiwibWFjIjoiNzQ5YWQ2NjViNzM0YThiNmY3OGFiNTU1ZTNjNzBjYTMxZGFlZDFmMTVkNDE4ZDU1ZDg5ODJmZGM4NDkzNGQ5ZSJ9"
    }
  ],
  "custom_qb_id": "6277",
  "custom_repli_id": "11680150098",
  "custom_realpage_id": "4059828",
  "custom_adtaxi_domain": "https://tags.tiqcdn.com/utag/adtaxi-pm/ashbrookrun.com/prod/utag.js",
  "custom_google_gtm_id": "GTM-MTMP3WN2",
  "custom_rollout_phase": "Phase 2",
  "custom_vibesites_theme": "Prestige",
  "custom_knock_community_id": "5811ed2102a530a6",
  "custom_knock_company_token": "c0c85c72a64e11edbd41023423a61a29",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "614-714-5083",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjlzdVQ4SjdiMUhEU2dWUllSNDI4cFE9PSIsInZhbHVlIjoiemltZ1hLcGM3NlB1MDRNZDZPYzI5dz09IiwibWFjIjoiNzQ5YWQ2NjViNzM0YThiNmY3OGFiNTU1ZTNjNzBjYTMxZGFlZDFmMTVkNDE4ZDU1ZDg5ODJmZGM4NDkzNGQ5ZSJ9",
  "custom_audioeye_site_id": "4efb0636-d127-4b74-b3a3-efaf2800e6c6",
  "custom_audioeye_site_hash": "59943e26b98cc2520024a3ea1b032b5d"
};

export const generatedAt = '2026-09-15T00:30:37.165Z';
